// @file Handles URL hash shortcuts for Surface
import window from '@@/bits/global'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePanelsStore } from '@@/pinia/surface_panels'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfaceSettingsStore } from '@@/pinia/surface_settings'

const HASH_SHORTCUTS = {
  Activity: '#activity',
  Remake: '#remake',
  Settings: '#settings',
  Share: '#share',
}

function resetHash(): void {
  history.replaceState('', document.title, window.location.pathname)
}

function useSurfaceUrlHashShortcuts(): void {
  const surfacePanelsStore = useSurfacePanelsStore()

  const currentHash = window.location.hash
  if (!Object.values(HASH_SHORTCUTS).includes(currentHash)) return

  switch (currentHash) {
    case HASH_SHORTCUTS.Activity:
      surfacePanelsStore.xSurfaceActivityPanel = true
      break
    case HASH_SHORTCUTS.Remake:
      if (useSurfacePermissionsStore().canIRemake) {
        useSurfacePanelsStore().xSurfaceRemakePanel = true
      }
      break
    case HASH_SHORTCUTS.Settings:
      if (useSurfaceStore().isFrozen || !useSurfacePermissionsStore().canIAdminister) break
      useSurfaceSettingsStore().showSettingsPanel()
      break
    case HASH_SHORTCUTS.Share:
      surfacePanelsStore.xSurfaceSharePanel = true
      break
  }

  resetHash()
}
export { useSurfaceUrlHashShortcuts }
